import script from "./DisbursementsTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementsTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./DisbursementsTableRow.vue?vue&type=style&index=0&id=7ed03c71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed03c71"]])

export default __exports__